import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetTermoUsoResponse } from 'src/app/services/TermoUsoService/termoUso.model';
import { TermoUsoService } from 'src/app/services/TermoUsoService/termoUso.service';
import Swal from 'sweetalert2';
import { formatarData } from '../../utils/utilities';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  authService = inject(AuthService);
  constructor(
    private router: Router,
    private termoUsoService: TermoUsoService,
    private appExport: AppExportBase64
  ) {}

  getNome(): string {
    const nome = String(localStorage.getItem('nome'));
    return nome;
  }

  logout() {
    this.router.navigate(['login']);

    localStorage.clear();
  }

  infoUserAccept() {
    this.termoUsoService.GetTermoUso().subscribe({
      next: response => {
        const formatarInfoTermo = (base: IGetTermoUsoResponse): string => {
          return `
          <strong>Data de aprovação do termo:</strong> ${formatarData(
            base.DT_TERM_ACPT
          )}<br>
          <strong>IP:</strong> ${base.TX_USER_IP}<br>
          <strong>Dispositivo:</strong> ${base.TX_USER_SO}<br>
          <strong>Navegador:</strong> ${base.TX_USER_BWSR}
        `;
        };

        Swal.fire({
          title: 'Termo de Uso',
          html: formatarInfoTermo(response),
          confirmButtonColor: '#173660',
          confirmButtonText: 'Visualizar termo de uso',
          showCancelButton: true,
          cancelButtonColor: '#173660',
          cancelButtonText: 'Visualizar termo de consentimento',
          showCloseButton: true
        }).then(result => {
          if (result.isConfirmed) {
            this.termoUsoService.GetLastTermoVersionByTipo(1).subscribe({
              next: downloadResponse => {
                this.appExport.guiaPdf(downloadResponse.File.Base64Content);
              }
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.termoUsoService.GetLastTermoVersionByTipo(2).subscribe({
              next: downloadResponse => {
                this.appExport.guiaPdf(downloadResponse.File.Base64Content);
              }
            });
          }
        });
      }
    });
  }

  navigateHome(): void {
    this.router.navigate(['home']);
  }
}
